import React, {createContext, useState} from "react";

export const AlertsContext = createContext({
    alert: "",
    setAlert: () => {},
})
export function AlertsProvider({children}){
    const [alert, setAlert] = useState("")

    return(
        <AlertsContext.Provider value={{
            alert,
            setAlert,
        }}>
            {children}
        </AlertsContext.Provider>
    )
}

export default AlertsContext;